<template>
  <div class="os-separator"></div>
</template>

<style scoped>
.os-separator {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: none;
  height: 0;
  border-top: solid 2px var(--background--primary);
  flex-grow: 0;
  flex-shrink: 0;
}
</style>
